import React from "react";
import { MapContainer, TileLayer, Marker, Popup, Polyline } from "react-leaflet";
import "leaflet/dist/leaflet.css";

// Dummy trade data
const importRoutes = [
    { from: [6.1725, 1.2314], to: [31.7917, -7.0926], product: "NPK Fertilizer (Morocco)", price: "€420/T" },
    { from: [6.1725, 1.2314], to: [35.8617, 104.1954], product: "Solar Pumps (China)", price: "€1,200/unit" },
];

const exportRoutes = [
    { from: [6.1725, 1.2314], to: [46.6034, 1.8883], product: "Pineapple (France)", price: "€800/T" },
    { from: [6.1725, 1.2314], to: [20.5937, 78.9629], product: "Sesame Seeds (India)", price: "€1,200/T" },
];

const HeroTradeMap = () => {
    const heroCoords = [6.1725, 1.2314]; // Togo coords (example)

    return (
        <div className="mt-4" style={{ height: "500px" }}>
            <MapContainer center={heroCoords} zoom={2} style={{ height: "100%", width: "100%" }}>
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />

                {/* Import routes */}
                {importRoutes.map((route, i) => (
                    <Polyline key={`import-${i}`} positions={[route.from, route.to]} color="blue">
                        <Popup>{route.product} - {route.price}</Popup>
                    </Polyline>
                ))}

                {/* Export routes */}
                {exportRoutes.map((route, i) => (
                    <Polyline key={`export-${i}`} positions={[route.from, route.to]} color="green">
                        <Popup>{route.product} - {route.price}</Popup>
                    </Polyline>
                ))}

                {/* Import Markers */}
                {importRoutes.map((route, i) => (
                    <Marker key={`import-marker-${i}`} position={route.to}>
                        <Popup>Import: {route.product} ({route.price})</Popup>
                    </Marker>
                ))}

                {/* Export Markers */}
                {exportRoutes.map((route, i) => (
                    <Marker key={`export-marker-${i}`} position={route.to}>
                        <Popup>Export: {route.product} ({route.price})</Popup>
                    </Marker>
                ))}
            </MapContainer>
        </div>
    );
};

export default HeroTradeMap;
